<div class="container">
    <div class="user-role-chip">
        <div (click)="onEditRole(role)" [class]="getClassName(role?.name)"
             *ngFor="let role of item.cells[fieldDefinition.key]?.value">{{role?.name}}</div>
    </div>
    <button *ngIf="hasAdminPermission && !isContactDialog(item)" (click)="AddRoleForUser()" class="add-user-role"
            mat-icon-button
            particleAnalytics
            analyticsCategory="roles-viewer"
            analyticsAction="add">
        <i class="fa-solid fa-plus"></i>
    </button>
</div>
